import type { ReactNode, HTMLAttributes } from 'react'

export function Card({ className = '', children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`card ${className}`} {...rest}>{children}</div>
}

/** Card with a title row: title, optional pill/extra, right-aligned actions. */
export function Panel({ title, extra, actions, children, className = '', bodyClassName = '' }: {
  title?: ReactNode; extra?: ReactNode; actions?: ReactNode; children?: ReactNode; className?: string; bodyClassName?: string
}) {
  return (
    <div className={`card card-pad ${className}`}>
      {(title || actions || extra) && (
        <div className="flex items-center gap-2 mb-2 min-h-7">
          {title && <h3 className="h3">{title}</h3>}
          {extra}
          {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  )
}

export function SectionTitle({ children, extra, className = '' }: { children: ReactNode; extra?: ReactNode; className?: string }) {
  return (
    <div className={`flex items-center gap-2 mb-2 ${className}`}>
      <div className="sectitle">{children}</div>
      {extra && <div className="text-[12px] text-muted normal-case tracking-normal font-normal">{extra}</div>}
    </div>
  )
}
